import { render, staticRenderFns } from "./pvalves.vue?vue&type=template&id=5159fad8&scoped=true"
import script from "./pvalves.vue?vue&type=script&lang=js"
export * from "./pvalves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159fad8",
  null
  
)

export default component.exports